export const searchDatasets = "searchDatasets";
export const searchCustomDatasets = "searchCustomDatasets";
export const searchAdminCustomDatasets = "searchAdminCustomDatasets";
export const searchAdminDatasets = "searchAdminDatasets";
export const optOutMfa = "optOutMfa";
export const clipManagementColumnVisibility = "clipManagement_columnVisibility";
